/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EventSearchRequest,
  EventSearchResponse,
} from '../models/index';
import {
    EventSearchRequestFromJSON,
    EventSearchRequestToJSON,
    EventSearchResponseFromJSON,
    EventSearchResponseToJSON,
} from '../models/index';

export interface SearchEventsPostRequest {
    eventSearchRequest: EventSearchRequest;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Search for live events and return normalized event, venue, sale, and approximate price metadata.
     */
    async searchEventsPostRaw(requestParameters: SearchEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventSearchResponse>> {
        if (requestParameters['eventSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'eventSearchRequest',
                'Required parameter "eventSearchRequest" was null or undefined when calling searchEventsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/events`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventSearchRequestToJSON(requestParameters['eventSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search for live events and return normalized event, venue, sale, and approximate price metadata.
     */
    async searchEventsPost(requestParameters: SearchEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventSearchResponse> {
        const response = await this.searchEventsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
